<template>
  <div>
    <div class="c_content">
      <!-- <div class="c_banner">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(items,index) in collectionType" @click="getCollectionByType1(items.id,index,items.name)">
              <span>{{items.name}}</span>
              <div :class="index==current?'cur':''"></div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="c_search">

        <div class="c_stype" v-on:click="toggletype">
          <span>{{ typess }}</span>
          <i class="down" v-if="!isTypeshow"></i>
          <i class="up" v-else></i>
        </div>

        <div class="c_syear" v-on:click="toggleyear">
          <span>{{ yearss }}</span>
          <i class="down" v-if="!isYearshow"></i>
          <i class="up" v-else></i>
        </div>
        <div class="c_skey">
          <input type="text" v-model="keyword" @keyup.enter="getCollectionss(false)">
          <img src="static/images/searchbtn.svg" alt="" v-on:click="getCollectionss(false)">
        </div>
      </div> -->
      <div class="search-box">
        <div class="search-item" v-on:click="toggletype">
          <span>{{ typess }}</span>
          <i class="down" v-if="!isTypeshow"></i>
          <i class="up" v-else></i>
        </div>
        <div class="search-item" v-on:click="toggleyear">
          <span>{{ yearss }}</span>
          <i class="down" v-if="!isYearshow"></i>
          <i class="up" v-else></i>
        </div>
      </div>




      <div class="collectList" v-show="dataFlag">
        <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
          <li @click="gotodetail(item.id)" v-for="item in collectionList" :key="item.id" class="collectItem"><img
              :src="item.pics[0] ? item.pics[0].url : ''" :onerror="defaultImg" alt="" /><span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <noData v-show="!dataFlag"></noData>
    </div>
    <div class="totals" :class="checked ? 'hide' : ''" fixed v-show="total"><span>共有{{ total }}件藏品</span></div>
    <div class="c_type" v-show="isTypeshow">
      <ul>
        <li v-for="(item, index) in collectionType" :key="item.id"
          @click="getCollectionByType(item.id, index, item.name)" :class="index == current ? 'cur' : ''"><span>{{
            item.name }}</span></li>
      </ul>
    </div>

    <div class="c_year" v-show="isYearshow">
      <ul>
        <li v-for="(item, index) in collectionYear.list" :key="item.id"
          @click="getCollectionByYear(item.id, index, item.name)" :class="index == current1 ? 'cur' : ''">
          <span>{{ item.name }}</span>
        </li>
      </ul>
      <p class="page-infinite-loading"></p>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { api } from '../global/api';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import noData from './noData';
import collectionYears from '../../static/dataJson/collectionYear.json';
export default {
  data() {
    return {
      defaultImg: 'this.src="' + require('@/assets/images/no-data.png') + '"',  // 默认图片

      collectionList: [],
      collectionType: [{ "id": "", "name": "全部" }],
      collectionYear: collectionYears,
      isTypeshow: false,
      isYearshow: false,
      loading: true,
      current: 0,
      current1: 0,
      collectType: "",
      collectYear: "",
      keyword: "",
      total: 0,
      page: 1,
      size: 8,
      checked: false,
      dataFlag: true,
      yearss: "年代",
      typess: "分类"
    }
  },
  components: { // 声明子组件
    noData
  },
  /*directives: {
    debounce: {
      inserted: function (el, binding) {
        let timer;
        el.addEventListener('keyup', () => {
          if (timer) {
            clearTimeout(timer)
          }
          timer = setTimeout(() => {
            binding.value()
          }, 1000)
        })
      }
    }
  },*/
  mounted() {
    this.collectType = this.$route.query.id ? Number(this.$route.query.id) : ''
    this.getType();
    //this.getYear();
    this.getCollections(true);
    this.scroll();

    var mySwiper = new Swiper('.swiper-container', {
      loop: false,
      slidesPerView: 4,
      initialSlide: 0,
      spaceBetween: between() / 2,
      observer: true,//修改swiper自己或子元素时，自动初始化swiper
      observeParents: true,//修改swiper的父元素时，自动初始化swiper
      on: {
        init: function () {
          //Swiper初始化了
          // setTimeout(function(){document.getElementsByClassName("swiper-wrapper")[0].style.transform="translate3d(0px,0px,0px)"},500);
          setTimeout(function () { document.getElementsByClassName("swiper-wrapper")[0].style.transform = "translate3d(0px,0px,0px)" }, 500);
        },
      }
    })
  },
  methods: {
    handleChange(index) {

    },
    getCollectionss(flag) {
      this.page = 1;
      this.getCollections(false);
    },
    loadMore() {
      this.loading = true;
      this.page++;
      this.getCollections(true);

      /*setTimeout(() => {
        this.page ++;
        this.getCollections(true);
      }, 1000);*/
    },
    scroll() {
      let that = this;
      window.addEventListener('scroll', function () {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 300) {
          that.checked = true;
        }
      }, true)
    },
    gotodetail(id) {
      this.$router.push({
        path: 'collectionDetail',
        query: { id: id }
      });
    },
    getCollections(flag) {
      let that = this;
      Indicator.open({ text: '加载中...', spinnerType: 'fading-circle' });
      let params = { collectionsCategory: this.collectType, year: this.collectYear, name: this.keyword, currentPage: this.page, size: this.size };
      this.$http.get(api.getCollectionList, { params: params }).then(response => {
        if (response.data.success == 1) {
          Indicator.close();
          if (flag) {
            that.collectionList = that.collectionList.concat(response.data.data);
            that.total = response.data.others.total;
            if (response.data.data.length == 0) {
              that.loading = true;
              that.checked = true;
            } else {
              that.loading = false;
            }
          } else {
            if (response.data.data.length > 0) {
              this.collectionList = response.data.data;
              that.total = response.data.others.total;
              this.loading = false;
              that.dataFlag = true;
              that.isYearshow = false;
              that.isTypeshow = false;
            } else {
              that.dataFlag = false;
              that.loading = true;
              that.isYearshow = false;
              that.isTypeshow = false;
            }
          }
        } else {
          console.log("接口异常");
        }
      }, response => {
      })
    },
    getType() {
      let that = this;
      this.$http.get(api.getCollectionSearch).then(response => {
        that.collectionType = that.collectionType.concat(response.data.data);
        that.current = that.collectType ? that.collectionType.findIndex(ele => Number(ele.id) == that.collectType) : 0
        that.typess = that.collectType ? that.collectionType.find(ele => Number(ele.id) == that.collectType).name : '分类'
        //  that.collectType= response.data.data[0].id
      }, response => {
      })
    },
    /*getYear(){
      let that = this;
      that.collectionYear = that.collectionYear.concat(collectionYear.list);
      // this.$http.get(api.collectionYear, {timeout:8000 }).then(response  => {
      //   that.collectionYear = that.collectionYear.concat(response.data.list);
      // //  that.collectYear= response.data.list[0].id;

      // }, response => {
      // })
    },*/
    getCollectionByType(id, i, name) {
      let that = this;
      this.current = i;
      this.collectType = id;
      this.page = 1;
      this.typess = name;
      this.isTypeshow = false
      this.getCollections(false)
    },
    getCollectionByType1(id, i, name) {
      let that = this;
      this.current = i;
      this.collectType = id;
      this.typess = name;
      this.page = 1;
      this.getCollections(false)
    },
    getCollectionByYear(id, i, name) {
      let that = this;
      this.current1 = i;
      this.collectYear = id;
      this.yearss = name;
      this.page = 1;
      this.isYearshow = false
      this.getCollections(false)
    },
    toggletype() {
      this.isTypeshow = !this.isTypeshow;
      this.isYearshow = false;
      if (this.isTypeshow == false) {
        this.dataFlag = true;
      } else {
        this.dataFlag = false;
      }

    },
    toggleyear() {
      this.isYearshow = !this.isYearshow;
      this.isTypeshow = false;
      if (this.isYearshow == false) {
        this.dataFlag = true;
      } else {
        this.dataFlag = false;
      }
    }
  },
}
</script>

<style scoped>
.c_content {
  padding: 0 .8rem;
  position: relative;
  padding-top: 2.4rem;
}

.c_banner {
  height: 2.25rem;
  width: 100%;
}

.swiper-slide {
  width: 100px;
}

/* .swiper-slide-active{
    border-bottom: 0.1rem solid rgba(196, 77, 65, 1);
  }*/
.swiper-slide div.cur {
  width: .8rem;
  /* background-color: rgba(196, 77, 65, 1); */
  background-image: linear-gradient(52deg, #56BAFF 0%, #44CCCC 100%);
  height: .1rem;
  position: absolute;
  bottom: 0;
  margin: auto;
  left: 0;
  right: 0;
}

.c_banner span {
  height: 2.25rem;
  line-height: 2.25rem;
  color: rgba(51, 51, 51, 1);
  font-size: 0.8rem;
  display: block;
  text-align: center;
  font-family: PingFang-SC-Bold;
}

.c_search {
  width: 100%;
  height: 1.45rem;
  padding: .4rem 0;
  background-color: rgba(255, 255, 255, 1);
}

.c_skey input {
  width: 9.6rem;
  height: 1.5rem;
  text-indent: 1.5rem;
  border: none;
  border-radius: 0.5rem;
  background-color: rgba(241, 241, 242, 1);
  border-width: 1px;
}

.c_skey {
  vertical-align: middle;
}

.c_stype,
.c_syear,
.c_skey {
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.c_syear span,
.c_stype span {
  width: 1.5rem;
  display: block;
  overflow: hidden;
  height: .8rem;
}

.c_stype {
  width: 2.8rem;
  height: 0.7rem;
  line-height: 0.7rem;
  color: rgba(51, 51, 51, 1);
  font-size: 0.7rem;
  text-align: left;
  font-family: PingFang-SC-Medium;
}

.c_stype i,
.c_syear i {
  position: absolute;
  right: .5rem;
  width: 9px;
  height: 5px;
  display: block;
}

.c_stype i.down,
.c_syear i.down {
  background: url("../../static/images/down.svg") center no-repeat;
  background-size: 100% 100%;
}

.c_stype i.up,
.c_syear i.up {
  background: url("../../static/images/up.svg") center no-repeat;
  background-size: 100% 100%;
}

.c_stype i,
.c_syear i,
.c_skey img {
  margin: auto;
  top: 0;
  bottom: 0;
}

.c_skey img {
  position: absolute;
  left: .5rem;
}

.c_syear {
  width: 2.8rem;
  height: 0.7rem;
  line-height: 0.8rem;
  color: rgba(51, 51, 51, 1);
  font-size: 0.7rem;
  text-align: left;
  font-family: PingFang-SC-Medium;
}

.collectList {
  width: 100%;
  margin-top: .5rem;
  padding-bottom: 2.45rem;
}

.collectList:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}

.collectList ul:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}

.collectItem {
  float: left;
  width: 8.25rem;
  height: 11rem;
  margin-bottom: .5rem;
}

.collectItem:nth-child(2n) {
  margin-left: .6rem;
}

.collectItem img {
  display: block;
  width: 8.25rem;
  height: 8.25rem;

}

.collectItem span {
  display: block;
  width: 100%;
  color: rgba(51, 51, 51, 1);
  font-size: 0.7rem;
  text-align: left;
  margin-top: .3rem;
  font-family: PingFang-SC-Regular;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制显示的行数 */
  line-clamp: 2; /* 标准属性，提高兼容性 */
  -webkit-box-orient: vertical;
}

.totals {
  width: 100%;
  height: 2rem;
  /* background-color: rgba(196, 77, 65, 1); */
  background-image: linear-gradient(52deg, #56BAFF 0%, #44CCCC 100%);
  text-align: center;
  position: fixed;
  /* bottom:2.45rem; */
  bottom: 0;
  z-index: 10000;
  opacity: 1;
}

.totals.hide {
  transition: all 0.5s ease-out;
  opacity: 0;
}

.totals span {
  width: 6.4rem;
  height: 2rem;
  line-height: 2rem;
  color: rgba(255, 255, 255, 1);
  font-size: 0.65rem;
  text-align: left;
  font-family: PingFang-SC-Medium;
}

.c_type,
.c_year {
  position: absolute;
  top: 2.4rem;
  width: 100%;
  /* height: 22.7rem; */
  background-color: rgba(241, 241, 242, 1);
  overflow: auto;
  z-index: 100;
}

.c_type ul:after,
.c_year ul:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}

.c_type ul,
.c_year ul {
  padding: 1rem .75rem;
}

.c_type li,
.c_year li {
  float: left;
  text-align: center;
  height: .7rem;
  border-radius: 0.75rem;
  border: 0.05rem solid rgba(153, 153, 153, 1);
  padding: .4rem .8rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
}

.c_type li.cur,
.c_year li.cur {
  background-image: linear-gradient(52deg, #56BAFF 0%, #44CCCC 100%);
  /* background-color: rgba(196, 77, 65, 1); */
  border: 0.05rem solid #56BAFF;
}

.c_type li.cur span,
.c_year li.cur span {
  color: rgba(255, 255, 255, 1);
}

.c_type span,
.c_year span {
  height: .7rem;
  line-height: .7rem;
  color: rgba(153, 153, 153, 1);
  font-size: 0.7rem;
  text-align: left;
  font-family: PingFang-SC-Medium;
  display: block;
}

.search-box{
  display: flex;
  align-items: center;
  height: 2.4rem;
  font-size: 0.7rem;
  border-bottom: 1px solid #eee;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.8rem;
  background-color: #fff;
}
.search-box .search-item{
  height: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 1rem;
}
.search-box .search-item i{
  width: 9px;
  height: 5px;
  margin-left: 0.5rem;
}
.search-box .search-item i.down {
  background: url("../../static/images/down.svg") center no-repeat;
  background-size: 100% 100%;
}

.search-box .search-item i.up {
  background: url("../../static/images/up.svg") center no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/collection.vue